import api from "../../config/api";
import { firebase } from "../../config/firebase";
export const FETCH_MERCHANDISE_TYPES = "FETCH_MERCHANDISE_TYPES";
export const FETCH_MERCHANDISE_TYPES_SUCCESS =
  "FETCH_MERCHANDISE_TYPES_SUCCESS";
export const FETCH_MERCHANDISE_TYPES_FAILURE =
  "FETCH_MERCHANDISE_TYPES_FAILURE";

export const fetchMerchandisetypes = () => ({
  type: FETCH_MERCHANDISE_TYPES,
});

export const fetchMerchandisetypesSuccess = (data) => ({
  type: FETCH_MERCHANDISE_TYPES_SUCCESS,
  data,
});

export const fetchMerchandisetypesFailure = (err) => ({
  type: FETCH_MERCHANDISE_TYPES_FAILURE,
  err,
});

export const getMerchandiseTypes = () => {
  return (dispatch) => {
    dispatch(fetchMerchandisetypes());
    return firebase.reloadAuth().then((res) => {
      try {
        const token = res.ya === null ? res.za : res.ya;

        api
          .get("/merchandise/types/", null, token)
          .then((res) => {
            dispatch(fetchMerchandisetypesSuccess(res));
            return res;
          })
          .catch((err) => dispatch(fetchMerchandisetypesFailure(err)));
      } catch (err) {
        console.log(err);
      }
    });
  };
};
